<div *ngIf="isLoading" class="d-flex justify-content-center py-3">
  <div class="spinner-border text-primary" role="status"></div>
</div>

<ng-container *ngIf="!isLoading">
  <!-- Action buttons — always visible -->
  <div class="d-flex justify-content-end mb-1">
    <button class="btn btn-outline-secondary btn-sm mr-1" (click)="syncPolicies()" [disabled]="isSyncing">
      <span *ngIf="isSyncing" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
      <span *ngIf="!isSyncing" class="feather icon-refresh-cw mr-1"></span>
      {{ 'INSURANCE.SYNC_BUTTON' | translate }}
    </button>
    <button class="btn btn-outline-primary btn-sm" (click)="goToInsurancePlatform()" [disabled]="isRedirecting">
      <span *ngIf="isRedirecting" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
      <span *ngIf="!isRedirecting" class="feather icon-external-link mr-1"></span>
      {{ 'INSURANCE.PLATFORM_BUTTON' | translate }}
    </button>
  </div>

  <!-- No policies yet -->
  <div *ngIf="getDocuments().length === 0" class="alert alert-warning">
    {{ 'INSURANCE.DETAILS.NO_POLICIES' | translate }}
  </div>

  <!-- Policies table -->
  <ng-container *ngIf="getDocuments().length > 0">
    <div class="font-weight-bold text-dark mb-1">{{ 'INSURANCE.DETAILS.POLICIES_TITLE' | translate }}</div>

    <div class="table-responsive">
      <table class="table table-sm content-table">
        <thead>
          <tr>
            <th>{{ 'INSURANCE.DETAILS.POLICY_NUMBER' | translate }}</th>
            <th>{{ 'INSURANCE.DETAILS.STATUS' | translate }}</th>
            <th>{{ 'INSURANCE.DETAILS.START_DATE' | translate }}</th>
            <th>{{ 'INSURANCE.DETAILS.END_DATE' | translate }}</th>
            <th>{{ 'INSURANCE.DETAILS.TOTAL' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let doc of getDocuments(); let i = index">
            <tr>
              <td style="max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{ doc.policyNumber || '-' }}
              </td>
              <td><span class="badge badge-pill badge-success">{{ doc.status || '-' }}</span></td>
              <td>{{ doc.startDate ? (doc.startDate | date:'dd/MM/yyyy') : '-' }}</td>
              <td>{{ doc.endDate ? (doc.endDate | date:'dd/MM/yyyy') : '-' }}</td>
              <td>
                <span *ngIf="getTotalInstallmentsForDoc(doc) > 0">
                  {{ getTotalInstallmentsForDoc(doc) | number:'1.2-2' }} {{ doc.premiumCurrency || 'RON' }}
                </span>
                <span *ngIf="getTotalInstallmentsForDoc(doc) === 0">-</span>
              </td>
              <td>
                <button class="btn btn-sm btn-outline-secondary" (click)="toggleDoc(i)">
                  <span [ngClass]="expandedDocIndex === i ? 'icon-chevron-up' : 'icon-chevron-down'" class="feather"></span>
                </button>
              </td>
            </tr>
            <!-- Details sub-row: series, product, installments -->
            <tr *ngIf="expandedDocIndex === i">
              <td colspan="6" class="bg-light p-2">

                <!-- Series + Product -->
                <div class="mb-2">
                  <div class="small" *ngIf="doc.policyNumber">
                    <strong>{{ 'INSURANCE.DETAILS.POLICY_NUMBER' | translate }}:</strong> {{ doc.policyNumber }}
                  </div>
                  <div class="small" *ngIf="doc.policySeries">
                    <strong>{{ 'INSURANCE.DETAILS.SERIES' | translate }}:</strong> {{ doc.policySeries }}
                  </div>
                  <ng-container *ngIf="doc.product">
                    <div class="small">
                      <strong>{{ 'INSURANCE.DETAILS.PRODUCT_NAME' | translate }}:</strong> {{ doc.product.name }}
                    </div>
                    <div class="small">
                      <strong>{{ 'INSURANCE.DETAILS.INSURER' | translate }}:</strong> {{ doc.product.insurer }}
                    </div>
                    <div class="small" *ngIf="doc.product.description && doc.product.description !== '-'">
                      <strong>{{ 'INSURANCE.DETAILS.PRODUCT_DESC' | translate }}:</strong> {{ doc.product.description }}
                    </div>
                  </ng-container>
                </div>

                <!-- Installments -->
                <div *ngIf="doc.installments?.length > 0">
                  <div class="font-weight-bold small mb-1">{{ 'INSURANCE.DETAILS.INSTALLMENTS' | translate }}</div>
                  <table class="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>{{ 'INSURANCE.DETAILS.INSTALLMENT_NUMBER' | translate }}</th>
                        <th>{{ 'INSURANCE.DETAILS.INSTALLMENT_DUE_DATE' | translate }}</th>
                        <th>{{ 'INSURANCE.DETAILS.INSTALLMENT_VALUE' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let inst of doc.installments" style="background-color: #fff;">
                        <td>{{ inst.number }}</td>
                        <td>{{ inst.dueDate | date:'dd/MM/yyyy' }}</td>
                        <td>{{ inst.value | number:'1.2-2' }} {{ doc.premiumCurrency || 'RON' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div *ngIf="!doc.installments?.length && !doc.product && !doc.policySeries && !doc.policyNumber" class="small text-muted">
                  {{ 'INSURANCE.DETAILS.NO_EXTRA_INFO' | translate }}
                </div>

              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>
</ng-container>
